import { Link } from 'react-router-dom';

export const DesktopSideNav = ({ title }) => {
  return (
    <div className='sidenav-con'>
      <div className='logo-dash'>
        <p>L</p>
      </div>
      <ul className='sidenav-list'>
        <Link
          to='/admin/dashboard'
          className={`list-item ${title === 'overall' && 'active'} tooltip`}
        >
          <li>
            <i className='fas fa-home'></i>
            <div className='tooltip-text'>
              <p>Dashboard</p>
            </div>
          </li>
        </Link>
        <Link
          to='/admin/dashboard/users'
          className={`list-item ${title === 'users' && 'active'} tooltip`}
        >
          <li>
            <i className='fas fa-user'></i>
            <div className='tooltip-text'>
              <p>Users</p>
            </div>
          </li>
        </Link>
        <Link
          to='/admin/dashboard/rides'
          className={`list-item ${title === 'rides' && 'active'} tooltip`}
        >
          <li>
            <i className='fas fa-car'></i>
            <div className='tooltip-text'>
              <p>Rides</p>
            </div>
          </li>
        </Link>
        <Link
          to='/admin/dashboard/drivers'
          className={`list-item ${title === 'drivers' && 'active'} tooltip`}
        >
          <li>
            <i className='fas fa-user-tie'></i>
            <div className='tooltip-text'>
              <p>Drivers</p>
            </div>
          </li>
        </Link>
        <Link
          to='/admin/dashboard/feedbacks'
          className={`list-item ${title === 'feedbacks' && 'active'} tooltip`}
        >
          <li>
            <i className='fas fa-comments'></i>
            <div className='tooltip-text'>
              <p>Feedbacks</p>
            </div>
          </li>
        </Link>
        <Link
          to='/admin/dashboard/settings'
          className={`list-item ${title === 'settings' && 'active'} tooltip`}
        >
          <li>
            <i className='fas fa-cog'></i>
            <div className='tooltip-text'>
              <p>Settings</p>
            </div>
          </li>
        </Link>
      </ul>
    </div>
  );
};
